import { render, staticRenderFns } from "./linkCom.vue?vue&type=template&id=fc96acc2&scoped=true"
import script from "./linkCom.vue?vue&type=script&lang=js"
export * from "./linkCom.vue?vue&type=script&lang=js"
import style0 from "./linkCom.vue?vue&type=style&index=0&id=fc96acc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc96acc2",
  null
  
)

export default component.exports